(ns story-builder.event.fx
  (:require
   [clojure.string :as str]
   [goog.dom :as gdom]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [story-builder.event.util :as event.util]
   [story-builder.util.core :as util]
   [story-builder.util.url :as util.url]))

(rf/reg-fx
 :dispatch-debounce
 (fn [[id event interval]]
   (event.util/dispatch-debounce {:id id, :interval interval} event)))

(rf/reg-fx
 :copy-to-clipboard
 (fn [data]
   (util/copy-to-clipboard data)))

(rf/reg-fx
 :throw-exception
 (fn [data]
   (util/exception data)))

(rf/reg-fx
 :reset-query-string
 (fn [data]
   (.replaceState js/history
                  js/undefined
                  js/undefined
                  (str js/window.location.pathname
                       (when-not (empty? data)
                         (str "?" (util.url/clj->qs data)))))))

(rf/reg-fx
 :merge-query-string
 (fn [data]
   (let [merged (util/remove-by str/blank? (merge (util.url/qs->clj) data))]
     (.replaceState js/history
                    js/undefined
                    js/undefined
                    (str js/window.location.pathname
                         (when-not (empty? merged)
                           (str "?" (util.url/clj->qs merged))))))))

(rf/reg-fx
 :download-from-url
 (fn [url]
   (let [download-element (gdom/createElement "a")]
     (.setAttribute download-element "href" url)
     (.setAttribute download-element "download" url)
     (gdom/appendChild js/document.body download-element)
     (.click download-element)
     (gdom/removeNode download-element))))

(rf/reg-fx
 ::open-url
 (fn [url target]
   (js/window.open url target)))

(rf/reg-fx
 ::scroll-to-top
 (fn [selector]
   (r/after-render
    (fn []
      (when-let [el (js/document.querySelector selector)]
        (set! (.-scrollTop el) 0))))))